module.exports = __webpack_public_path__ + "static/media/national-insurance-company-india-logo.4c005399.png";